module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_0@3x.fbc16e83.png";